import {useNuxtApp} from "nuxt/app";

/**
 * The IETF BCP 47 standard holds both country and language description.
 * https://en.wikipedia.org/wiki/IETF_language_tag#List_of_common_primary_language_subtags
 */
const langAndReg: Record<"fi" | "et", string> = {
	fi: "fi-FI",
	et: "et-EE",
};

export function useLocalization() {
	const {$i18n} = useNuxtApp();
	const languageTag = langAndReg[$i18n.locale.value as "fi" | "et"];

	return {
		languageTag,
	};
}
